import { render } from "./home-three-recommended.vue?vue&type=template&id=12b40dad"
import script from "./home-three-recommended.vue?vue&type=script&lang=js"
export * from "./home-three-recommended.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__